import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from "@/views/LoginView.vue";
import RecetasView from '@/views/RecetasView.vue'
import AlarmsView from '@/views/AlarmsView.vue'
import DataloggerView from '@/views/DataloggerView.vue'
import AjustesView from '@/views/AjustesView.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta:{
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: 'Home',
          content: 'Página principal de la app para ' + process.env.VUE_APP_COMPANY
        },
      ]
    }
  },
  // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    // },
    {
      path: '/recetas',
      name: 'recetas',
      component: RecetasView,
      meta:{
        requiresAuth: true,
        title: process.env.VUE_APP_TITLE,
        metaTags: [
          {
            name: 'Recetas',
            content: 'Página de recetas de la app para ' + process.env.VUE_APP_COMPANY
          },
        ]
      }
    },
    {
      path: '/alarmas',
      name: 'alarmas',
      component: AlarmsView,
      meta:{
        requiresAuth: true,
        title: process.env.VUE_APP_TITLE,
        metaTags: [
          {
            name: 'Alarmas',
            content: 'Página de alarmas de la app para ' + process.env.VUE_APP_COMPANY
          },
        ]
      }
    },
    {
      path: '/ajustes',
      name: 'ajustes',
      component: AjustesView,
      meta:{
        requiresAuth: true,
        title: process.env.VUE_APP_TITLE,
        metaTags: [
          {
            name: 'Ajustes',
            content: 'Página de ajustes de la app para ' + process.env.VUE_APP_COMPANY
          },
        ]
      }
    },
    {
      path: '/datalogger',
      name: 'datalogger',
      component: DataloggerView,
      meta:{
        requiresAuth: true,
        title: process.env.VUE_APP_TITLE,
        metaTags: [
          {
            name: 'Datalogger',
            content: 'Página de historicos de la app para ' + process.env.VUE_APP_COMPANY
          },
        ]
      }
    },
    {
      path: "/login",
      name: "login",
      component: LoginView,
      meta:{
        title: process.env.VUE_APP_TITLE,
        metaTags: [
          {
            name: 'Login',
            content: 'Página de Login de la app de ' + process.env.VUE_APP_COMPANY
          },
        ]
      }
    },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('token')
  
  // console.log("Es adminnnnnnnnnnnnn: "+is_admin);
  const pageTitle = to.meta.title
  if (pageTitle){
    document.title = `${pageTitle} - ${to.meta.metaTags[0].name}`
  } 
  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    console.log('not logged in')
    next({name:'login'})
  } else {
    // if(to.path == '/users'){ // evitamos que se entre a la gestión de usuarios si no es admin o avanzado
    //   let is_admin = JSON.parse(localStorage.getItem("user"))
    //   if(is_admin){
    //     is_admin = (is_admin.role_name == 'admin') || (is_admin.role_name == 'avanzado')
    //     if(is_admin)
    //       next()
    //     else{
    //       router.push({name:'home'})
    //       console.log("no puede entrar a la gestion de usuarios")
    //     }  
    //   }
    // }
    if (loggedIn ? to.path !== '/login' : true) next();
  }
})

export default router
